/*
 * Copyright (c) 2019. Willker Gomes
 */
import styled, { css } from 'styled-components';

export const DroppableContainer = styled.div`
  background: ${props => (props.isDraggingOver ? '#d0d0d0' : '#f2f2f2')};
  padding-bottom: 10px;
  padding-top: 1px;
  margin-top: 10px;
`;

export const DraggableItem = styled.div`
  padding: 10px;
  margin: 10px 10px 0 10px;
  user-select: none;
  background: #fff;
  ${props =>
    props.isDragging &&
    css`
      border: 1px solid #00000055;
      -webkit-box-shadow: 0px 3px 4px 0px rgba(46, 50, 50, 0.48);
      -moz-box-shadow: 0px 3px 4px 0px rgba(46, 50, 50, 0.48);
      box-shadow: 0px 3px 4px 0px rgba(46, 50, 50, 0.48);
    `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  form {
    span {
      font-size: 16px;
      color: #707070;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    padding: 12px 30px;
    border-radius: 4px;
    border-color: #b1aeae;
    border-width: 1px;
    font-size: 16px;
    box-shadow: 0 1px 3px rgb(0, 0, 0, 0.16);
    background: #eaeaea;

    @media (max-width: 450px) {
      font-size: 12px;
      padding: 6px 15px;
    }
  }
`;

export const ImageContent = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: 12px;
  }
`;
